import { FC, useCallback, useState } from 'react';
import { DateInput } from '../../../components/shared/date/DateInput';
import { createErrorToast } from '../../../services/notification/ToastService';
import strings from '../roster.translations';

interface OptimiserDateRangeProps {
  startDate: Date | undefined;
  endDate: Date | undefined;
  changeDatesCallback: (newStartDate?: Date, newEndDate?: Date) => void;
  minStartDate?: Date;
}

export const OptimiserDateRange: FC<OptimiserDateRangeProps> = ({
  startDate,
  endDate,
  changeDatesCallback,
  minStartDate
}) => {
  const [errorMessage, setErrorMessage] = useState<string | undefined>();

  const validateDates = useCallback(
    (startDate?: Date, endDate?: Date) => {
      if (!startDate || !endDate) {
        setErrorMessage(undefined);
      } else if (startDate < endDate) {
        setErrorMessage(undefined);
      } else {
        setErrorMessage('Start date must be before end date.');
      }
    },
    [setErrorMessage]
  );

  return (
    <div>
      <div className="flex flex-row gap-8 items-center justify-center">
        <div className="flex flex-col items-start">
          <p className="text-sm font-medium">{strings.optimiseRosters.startDate}</p>
          <DateInput
            name={'start'}
            onChange={(newDate: Date | undefined) => {
              changeDatesCallback(newDate, endDate);
              validateDates(newDate, endDate);
            }}
            value={startDate}
            minDate={minStartDate}
          />
        </div>
        <div className="flex flex-col items-start">
          <p className="text-sm font-medium">{strings.optimiseRosters.endDate}</p>
          <DateInput
            name={'end'}
            onChange={(newDate: Date | undefined) => {
              changeDatesCallback(startDate, newDate);
              validateDates(startDate, newDate);
            }}
            value={endDate}
            minDate={startDate}
          />
        </div>
      </div>
      {errorMessage && <div className="text-red-500">{errorMessage}</div>}
    </div>
  );
};
